import { render, staticRenderFns } from "./RsaSchedaInterventiSocioAssistenzialiEditComponent.vue?vue&type=template&id=feb8d70a"
import script from "./RsaSchedaInterventiSocioAssistenzialiEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaSchedaInterventiSocioAssistenzialiEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports